import SingleColumn from "@/views/SingleColumn.vue";
import BoosterCCS from "@/components/BoosterCCS/index";

export default [
  {
    path: "/booster-ccs/form",
    name: "booster_ccs_form",
    component: SingleColumn,
    props: {
      content: BoosterCCS,
      switchOrderMobile: true,
    },
    meta: {
      requiredLang: ["fr"],
    },
  },
];
